export const SORT_DESC = 'DESC';
export const SORT_ASC = 'ASC';

export const SORT_BY_DEFAULT = 'default';
export const SORT_BY_DATE = 'date';
export const SORT_BY_NAME = 'name';
export const SORT_BY_TRENDING = 'trending';
